<template>
	<div class="wrapper fade-in">
		<div
			id="wf-tour-webhook-test-header"
			style="
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				height: 300px;
				pointer-events: none;
				z-index: 5;
			"
		></div>
		<div class="actionsContainer">
			<el-tooltip content="Copy to clipboard" placement="top">
				<el-button
					@click="copyData()"
					type="text"
					icon="el-icon-document-copy"
					style="font-size: 16px; margin-right: 0px;"
				></el-button>
			</el-tooltip>
			<el-button
				id="wf-tour-insert-test-data-btn"
				:disabled="operationInProgress || readOnlyMode || workflow.isActive"
				@click="toggleEditor()"
				type="text"
			>
				{{ editTestData ? "Save" : "Insert" }} test {{ activeTab }} data
			</el-button>
		</div>
		<webhookEventListen
			:integration="integration"
			:workflow="workflow"
			v-if="operationInProgress && integration.type === 'webhook' && mounted"
		>
			<el-button
				:loading="stopWebhookTestOperationInProgress"
				style="margin: auto; display: block"
				@click="terminateWebhookTest()"
				type="text"
				>End test</el-button
			>
		</webhookEventListen>
		<el-tabs v-model="activeTab">
			<el-tab-pane :disabled="editTestData" label="JSON Data" name="json">
				<div v-loading="operationInProgress" class="tabContent">
					<vue-json-pretty
						:showIcon="true"
						:showLength="true"
						style="padding-bottom: 20px"
						:data="returnJson"
						:collapsedOnClickBrackets="false"
						:showLine="true"
						v-if="!editTestData && !operationInProgress && mounted"
					/>
					<jsonInput
						height="700px"
						@jsonModified="
							(json) => {
								testJson = json;
							}
						"
						:json="testJson"
						v-if="editTestData"
					/>
				</div>
			</el-tab-pane>
			<el-tab-pane :disabled="editTestData" label="Binary Data" name="binary">
				<div v-loading="operationInProgress" class="tabContent">
					<vue-json-pretty
						:showIcon="true"
						:showLength="true"
						style="padding-bottom: 20px"
						:data="returnBinary"
						:collapsedOnClickBrackets="false"
						:showLine="true"
						v-if="!editTestData && !operationInProgress && mounted"
					/>
					<jsonInput
						height="700px"
						@jsonModified="
							(json) => {
								testJson = json;
							}
						"
						:json="testJson"
						v-if="editTestData"
					/>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
import Vue from "vue";
import jsonInput from "./jsonInput.vue";
import webhookEventListen from "./webhookEventListen.vue";
let sse;
export default {
	components: {
		VueJsonPretty,
		jsonInput,
		webhookEventListen,
	},
	props: {
		integration: Object,
		workflow: Object,
		readOnlyMode: Boolean,
	},
	watch: {
		integration: function () {
			if (this.integration.outputData.length) {
				this.outgoingData = this.integration.outputData;
			} else {
				this.outgoingData = [{ json: {}, binary: {} }];
			}
		},
	},
	computed: {
		returnJson() {
			return this.outgoingData
				.map((each) => {
					return each.json;
				})
				.filter((each) => {
					if (each) {
						return each;
					}
				});
		},
		returnBinary() {
			return this.outgoingData
				.map((each) => {
					return each.binary;
				})
				.filter((each) => {
					if (each) {
						return each;
					}
				});
		},
	},
	beforeDestroy() {
		if (sse) {
			//If the integration was switched, then kill the sse connection and reset the loaders
			if (this.integration.type === "webhook" && this.testingWebhook) {
				//Delete test webhook in back end, don't use async
				this.testingWebhook = false;
				this.terminateWebhookTest();
			}
			this.$emit("operationComplete");
			sse.disconnect();
			this.stopLoading();
		}
	},
	mounted() {
		setTimeout(() => {
			this.mounted = true;
			this.operationInProgress = false;
		}, 500);
		if (this.integration.outputData.length) {
			this.outgoingData = this.integration.outputData;
		}
	},
	data() {
		return {
			mounted: false,
			testingWebhook: false,
			stopWebhookTestOperationInProgress: false,
			testJson: "",
			editTestData: false,
			activeTab: "json",
			operationInProgress: true,
			outgoingData: [{ json: {}, binary: {} }],
		};
	},
	methods: {
		async terminateWebhookTest() {
			this.stopWebhookTestOperationInProgress = true;
			await this.httpHelper("RUNTIME", "POST", "workflow/stopWebhookTest", {
				workflowId: this.workflow.id,
				nodeId: this.integration.id,
				versionId: this.workflow.versionId
			});
			this.stopLoading();
		},
		toggleEditor() {
			let assigmentSucceful;
			if (!this.editTestData) {
				//Editor will be shown
				try {
					const currentOutgoingDataForType = this.outgoingData
						.map((each) => {
							return each[this.activeTab];
						})
						.filter((each) => {
							if (each) {
								return each;
							}
						});
					this.testJson = JSON.stringify(currentOutgoingDataForType, null, 4);
					assigmentSucceful = true;
				} catch {
					assigmentSucceful = false;
				}
			} else {
				//Editor will be hidden
				try {
					const parsedData = JSON.parse(this.testJson);
					if (
						!Array.isArray(parsedData) ||
						!parsedData.every((each) => typeof each === "object" && !Array.isArray(each))
					) {
						throw new Error();
					}
					const formattedParsedData = parsedData.map((each) => {
						return { [this.activeTab]: each };
					});
					//Determine longest array of data and use that to loop over and combine
					const maxLength = Math.max(formattedParsedData.length, this.outgoingData.length);
					const mergedArray = [];
					for (let i = 0; i < maxLength; i++) {
						const newDataObject = formattedParsedData[i] || {};
						const existingDataObject = this.outgoingData[i] || {};
						if (!formattedParsedData[i]) {
							delete existingDataObject[this.activeTab];
						}
						mergedArray.push({ ...existingDataObject, ...newDataObject });
					}
					this.outgoingData = mergedArray;
					this.integration.outputData = mergedArray;
					assigmentSucceful = true;
				} catch {
					assigmentSucceful = false;
				}
			}
			if (assigmentSucceful) {
				this.editTestData = !this.editTestData;
			} else {
				this.$notifyError(
					this,
					"unable to add test output data. Invalid JSON or format. Data must be array of objects"
				);
			}
		},
		removeNonISO88591Characters(inputString) {
			// Use a regular expression to match characters outside the ISO-8859-1 range
			const iso88591Regex = /[^\u0000-\u00FF]/g;
			const sanitizedString = inputString.replace(iso88591Regex, "");
			return sanitizedString;
		},
		async initTestCallDataPreFlight({ nodeId, workflowId, credentialId, inputData, versionId }) {
			const result = await this.httpHelper("RUNTIME", "POST", "workflow/testNodeDataPreflight", {
				nodeId,
				workflowId,
				credentialId,
				inputData,
				versionId: versionId ?? null
			});
			if (result?.error) {
				this.$notifyError(this, "An issue arose while sending incoming data as part of the test");
			}
		},
		async initTestCall() {
			if (this.integration.type === "webhook") {
				this.testingWebhook = true;
			}
			const nodeId = this.integration.id;
			const workflowId = this.workflow.id;
			// Send larger data ie inputData ahead via post request before establishing SSE
			await this.initTestCallDataPreFlight({
				nodeId,
				workflowId,
				credentialId: this.integration.credentialId,
				inputData: this.integration.inputData,
				versionId: this.workflow.versionId
			});
			const authtoken = Vue.$cookies.get("accessToken") ? "Bearer " + Vue.$cookies.get("accessToken") : null;
			this.operationInProgress = true;
			sse = this.$sse.create({
				url: `${process.env.VUE_APP_RUNTIME_ENDPOINT}/workflow/testNode?workflowId=${workflowId}&nodeId=${nodeId}&versionId=${this.workflow.versionId}`,
				format: "json",
				polyfill: true,
				forcePolyfill: true,
				polyfillOptions: {
					headers: {
						Authorization: authtoken,
						// credential: this.integration.credentialId,
						// inputs: this.removeNonISO88591Characters(JSON.stringify(this.integration.inputData)),
					},
					heartbeatTimeout: 59000,
				},
			});
			sse.on("message", (msg) => {
				if (msg.outputData) {
					setTimeout(() => {
						this.integration.outputData = msg.outputData;
						this.outgoingData = msg.outputData;
					}, 500);
				}
				if (msg.message) {
					setTimeout(() => {
						this.$notify({
							title: "Log Message",
							message: msg.message,
							type: "info",
							position: "bottom-right",
						});
					}, 100);
				}
				if (msg.error) {
					try {
						const error = JSON.parse(msg.error);
						if (error.warning) {
							this.$notify({
								title: "Notification",
								message: error.warning,
								type: "info",
								position: "bottom-left",
							});
						} else {
							this.$notifyError(this, msg.error);
						}
					} catch {
						this.$notifyError(this, msg.error);
					}
				}
				if (!msg.keepConnectionAlive) {
					sse.disconnect();
					this.stopLoading();
				}
			});
			sse.on("error", (err) => {
				this.stopLoading();
				if (sse) {
					sse.disconnect();
				}
				this.$notifyError(this, "An unknown Error occurred while testing this integration");
				console.error("Failed to parse or lost connection:", err);
			});
			sse.connect().catch((err) => {
				this.stopLoading();
				if (sse) {
					sse.disconnect();
				}
				this.$notify({
					title: "Notification",
					message: "Test window failed to initiate or timed out",
					type: "info",
					position: "bottom-left",
				});
				console.error("Failed make initial connection:", err);
			});
		},
		stopLoading() {
			setTimeout(() => {
				this.$emit("operationComplete");
				this.operationInProgress = false;
				this.stopWebhookTestOperationInProgress = false;
			}, 1000);
		},
		async copyData() {
			try {
				const dataToCopy = this.activeTab === 'json' ? this.returnJson : this.returnBinary;
				await navigator.clipboard.writeText(JSON.stringify(dataToCopy, null, 4));
				this.$notify({
					title: "Success",
					message: "Data copied to clipboard!",
					type: "success",
					position: "bottom-right",
				});
			} catch (err) {
				this.$notifyError(this, "Failed to copy data");
			}
		},
	},
};
</script>

<style scoped>
.wrapper {
	padding: 20px;
	position: relative;
}

.tabContent {
	overflow: scroll;
	height: calc(100vh - 280px);
	padding-right: 20px;
	padding-top: 20px;
}

.actionsContainer {
	position: absolute;
	right: 20px;
	top: 18px;
	z-index: 10;
	display: flex;
	align-items: center;
}

.wrapper /deep/ .el-tabs__header {
	margin-bottom: 0px !important;
}

.wrapper /deep/ .vjs-tree-node {
	cursor: auto !important;
}

.wrapper /deep/ .vjs-tree-node:hover:after {
	display: none !important;
}
</style>
